export class LogoSettings {
  constructor(overrides) {
    const defaults = {
      url: 'https://i.pinimg.com/originals/5a/ae/50/5aae503e4f037a5a4375944d8861fb6a.png',
      width: {
        type: 'px',
        value: 170
      }
    };
    Object.assign(this, defaults, overrides);
  }
}
export const LogoTypes = {
  content: {
    url: {
      title: 'URL',
      type: 'Input',
      validate: value => {
        return /\.(png|jpg|jpeg)$/.test(value) !== true ? ["Only PNG and JPG images are supported."] : [];
      }
    }
  },
  orientation: {
    width: {
      title: 'Width',
      type: 'Size'
    }
  }
};